import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false
};


export default function achiev_points (state = initialState, action) {
  switch (action.type) {
    case types.SET_ACHIEV_POINTS_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_ACHIEV_POINTS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}